import { UserRole } from '../types/common';

export const getRoleFromScopes = (scopes: string[]) => {
  if (scopes.includes('role.superadmin')) {
    return UserRole.SuperAdmin;
  }
  if (scopes.includes('role.broker')) {
    return UserRole.Broker;
  }
  if (scopes.includes('role.seller')) {
    return UserRole.Seller;
  }
  return null;
};
